import axios from "axios";

const headers = (apimSubscriptionKey: string) => ({
  "Content-Type": "application/json;charset=utf-8",
  Accept: "application/json",
  crossDomain: true,
  'Ocp-Apim-Subscription-Key': apimSubscriptionKey
});

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: headers(process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY as string),
  timeout: 60000,
  withCredentials: true,
});

export { api };
